(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whp-vip-access"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whp-vip-access')) {
    customElements.define(
      'whp-vip-access',
      class WhpVipAccess extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.input = this.querySelector('input[type="email"]');
          this.status = this.querySelector('.whp-access__status');
          this.label = this.querySelector('[data-label]');
          this.original = this.label ? this.label.textContent : '';
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.verify();
          });
        }
        say(message, tone) {
          this.status.hidden = !message;
          this.status.textContent = message || '';
          this.status.dataset.tone = tone || '';
        }
        async verify() {
          const email = this.input.value.trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.say('Please enter a valid email address.', 'error');
            this.input.focus();
            return;
          }
          this.say('', '');
          if (this.label) this.label.textContent = 'Checking…';
          this.form.querySelector('button').disabled = true;
          try {
            const response = await fetch(this.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email, shop_id: this.dataset.shop }),
              cache: 'no-store',
            });
            const data = await response.json().catch(() => ({}));
            const result = data && (data.Result || data.result);
            if (response.ok && result && result.active === true) {
              const value = encodeURIComponent(this.dataset.key || '');
              document.cookie = 'hp_vip_access=' + value + '; path=/; max-age=86400; SameSite=Lax';
              this.say('You’re in. Opening the VIP collection…', 'ok');
              window.location.href = this.dataset.next;
              return;
            }
            this.say(response.ok && result ? this.dataset.msgInactive : this.dataset.msgError, 'error');
          } catch (e) {
            this.say(this.dataset.msgError, 'error');
          }
          if (this.label) this.label.textContent = this.original;
          this.form.querySelector('button').disabled = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whp-vip-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.whpJoinBound) {
  window.whpJoinBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-whp-join]');
    if (!form) return;
    event.preventDefault();
    const id = Number(form.querySelector('[name="id"]').value);
    const label = form.querySelector('[data-label]');
    const original = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      const inCart = cart.items.some((item) => item.variant_id === id);
      const url = root + (inCart ? 'cart/update.js' : 'cart/add.js');
      const body = inCart ? { updates: { [id]: 1 } } : { items: [{ id, quantity: 1 }] };
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('cart');
      window.location.href = root + 'cart';
    } catch (e) {
      if (label) label.textContent = original;
      form.submit();
    }
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whp-vip-steps"] && !Shopify.designMode) return;
  try {
    
  if (!window.whpJoinBound) {
  window.whpJoinBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-whp-join]');
    if (!form) return;
    event.preventDefault();
    const id = Number(form.querySelector('[name="id"]').value);
    const label = form.querySelector('[data-label]');
    const original = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      const inCart = cart.items.some((item) => item.variant_id === id);
      const url = root + (inCart ? 'cart/update.js' : 'cart/add.js');
      const body = inCart ? { updates: { [id]: 1 } } : { items: [{ id, quantity: 1 }] };
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('cart');
      window.location.href = root + 'cart';
    } catch (e) {
      if (label) label.textContent = original;
      form.submit();
    }
  });
  }

  } catch(e) { console.error(e); }
})();
})();
